import { render, staticRenderFns } from "./ttshop_security.vue?vue&type=template&id=7b677d68&scoped=true&"
import script from "./ttshop_security.vue?vue&type=script&lang=js&"
export * from "./ttshop_security.vue?vue&type=script&lang=js&"
import style0 from "./ttshop_security.vue?vue&type=style&index=0&id=7b677d68&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7b677d68",
  null
  
)

export default component.exports